import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AvailabilityModal } from "../AvailabilityModal";
import SameDayAvailabilityCard from "@/pages/jobs/components/SameDayAvailabilityCard";

/**
 * Standalone shareable route: same same-day UI as the dashboard (card + modal),
 * without RootLayout chrome.
 */
export default function ConfirmSameDayAvailabilityPage() {
  const [showModal, setShowModal] = useState(true);

  return (
    <div className="min-h-dvh bg-zinc-50 px-4 py-8 md:px-6 md:py-10">
      <div className="mx-auto w-full max-w-2xl space-y-8">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 text-sm font-medium text-zinc-600 transition-colors hover:text-zinc-900"
        >
          <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
          Back to dashboard
        </Link>

        <header className="space-y-3 text-center md:text-left">
          <p className="text-xs font-semibold uppercase tracking-wide text-[#ED5E00]">
            Same-day projects
          </p>
          <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 md:text-[1.75rem] md:leading-snug">
            Confirm your availability
          </h1>
          <p className="mx-auto max-w-xl text-[15px] leading-relaxed text-zinc-600 md:mx-0">
            Quick page for same-day availability: use the card for visibility,
            then{" "}
            <span className="font-medium text-zinc-800">Modify slots</span> for
            dates and times.
          </p>
        </header>

        <SameDayAvailabilityCard
          setShowModifySlot={() => setShowModal(true)}
        />
      </div>
      <AvailabilityModal isOpen={showModal} setOpen={setShowModal} />
    </div>
  );
}
